<template>
  <tr :class="{ shadow: localData.role === 'Shadow' }">
    <td
      v-for="(header, index) in headers.filter((h) => !h.hidden)"
      :key="index"
    >
      <template v-if="header.value === 'estimationRole.name'">
        <v-text-field
          id="project-estimate-name-input"
          v-model="localData.name"
          data-cy="project-estimate-input"
          class="secondary-background"
          label="Name"
          hide-details
          required
          outlined
          dense
          :rules="[(bs) => !!bs.trim() || 'Name is required']"
        />
      </template>
      <template v-else-if="header.value === 'estimationRole.description'">
        <v-textarea
          id="project-description-description-input"
          v-model="localData.description"
          data-cy="project-description-input"
          class="secondary-background"
          label="Description"
          hide-details
          required
          outlined
          dense
          :rules="[(bs) => !!bs.trim() || 'Description is required']"
        />
      </template>
      <template v-else-if="header.value === 'estimationRole.rate'">
        <v-text-field
          id="project-estimate-rate-input"
          v-model="localData.rate"
          data-cy="project-estimate-input"
          class="secondary-background"
          label="Rate"
          type="number"
          hide-details
          required
          outlined
          dense
          :rules="[(bs) => (bs >= 0) || 'Rate is required']"
        />
      </template>
      <template v-else-if="header.value === 'estimationRole.salary'">
        <v-text-field
          id="project-estimate-salary-input"
          v-model="localData.salary"
          data-cy="project-estimate-input"
          class="secondary-background"
          label="Salary"
          type="number"
          hide-details
          required
          outlined
          dense
          :rules="[(bs) => (bs >= 0) || 'Salary is required']"
        />
      </template>
      <template v-else-if="header.value === 'estimationRole.overhead'">
        <v-text-field
          id="project-estimate-overhead-input"
          v-model="localData.overhead"
          data-cy="project-estimate-input"
          class="secondary-background"
          label="Overhead"
          type="number"
          hide-details
          required
          outlined
          dense
          :rules="[(bs) => (bs >= 0) || 'Overhead is required']"
        />
      </template>
    </td>
    <td>
      <v-row>
        <v-btn
          text
          icon
          small
          @click.stop="updateEstimation()"
        >
          <v-icon>mdi-check</v-icon>
        </v-btn>
        <v-btn
          text
          icon
          small
          @click.stop="cancelEdit()"
        >
          <v-icon>mdi-cancel</v-icon>
        </v-btn>
      </v-row>
    </td>
  </tr>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';

import { projectStatusFilterValues } from '@/constants/projectStatuses';
import { projectTypes } from '@/constants/projectTypes';
import { NotificationHelper } from '@/helpers/notification.helper';

export default {
  name: 'ProjectEstimationRoleInput',
  components: {
  },
  props: {
    estimationRole: {
      type: Object,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      endDateMenu: false,
      startDateMenu: false,
      localData: this.getInitValue(),
      projectStatusFilterValues,
      projectTypes,
    };
  },
  computed: {
    ...mapGetters('user/settings', ['denseTables', 'dateFormatSettings']),
    ...mapGetters('projects/main', ['project', 'search']),
  },
  mounted() {},
  methods: {
    cancelEdit() {
      this.$emit('cancel');
    },
    validate() {
      if (this.localData.salary < 0) {
        NotificationHelper.showError('Estimation cannot be negative');

        return false;
      }

      if (this.localData.rate < 0) {
        NotificationHelper.showError('Rate cannot be negative');

        return false;
      }

      if (this.localData.overhead < 0) {
        NotificationHelper.showError('Overhead cannot be negative');

        return false;
      }

      return true;
    },
    updateEstimation() {
      if (!this.validate()) return;

      this.$emit('save', this.localData);
    },
    getInitValue() {
      const localData = _.cloneDeep(this.estimationRole);

      return localData;
    },
  },
};
</script>

<style lang="less">
@import "~variables";

.row-editor {
  .project-input {
    max-width: 270px;
  }

  .v-label {
    font-size: @table-font-size;
  }

  .v-text-field__slot {
    font-size: @table-font-size;
  }

  .v-text-field {
    input {
      font-size: @table-font-size;
    }
  }

  .clipped div.v-select__selection {
    overflow: hidden;
    white-space: nowrap;
  }

  // Validation error message
  .v-input {
    .v-text-field__details {
      overflow: visible;
    }

    .v-messages__message {
      position: absolute;
      background: @soft-peach;
      border: 1px solid @pink;
      border-radius: 0 2px 2px 2px;
      width: max-content;
      max-width: 120px;
      padding: 3px;
      color: @red-dark;
      box-shadow: 0 -1px 8px 2px @pink-light;

      &::before {
        content: "";
        position: absolute;
        border: solid transparent;
        border-width: 0 6px 5px 0;
        border-bottom-color: @pink;
        top: -5px;
        left: -1px;
      }
    }
  }
  .time__cell {
    position: relative;
  }
}
</style>
